var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.root},[_c('TheHeader',{on:{"child-checkbox":_vm.checkboxValue}}),_vm._v(" "),_c('main',{class:[
      _vm.$style.main,
      ( _obj = {}, _obj[_vm.$style.menuOpen] = _vm.showMenu, _obj )
    ]},[_vm._t("default")],2),_vm._v(" "),_c('TheFooter',{class:[( _obj$1 = {}, _obj$1[_vm.$style.menuOpen] = _vm.showMenu, _obj$1 )]})],1)
var _obj;
var _obj$1;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e050c68e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheLayout.vue
// module id = null
// module chunks = 